import { DocumentationsDataType } from './documentations.types';

export const mockedApplicationDocumentationsData: DocumentationsDataType[] = [
  {
    application_id: '6c31caf1-4d79-4abf-8c3e-dc50e263b63b',
    documentations: [
      {
        id: '6c31caf1-4d79-4abf-8c3e-dc50e263b634',
        name: 'Doc 1',
        support_description: 'Supp desc 1',
        url: 'http://url.com',
      },
    ],
    licenses: [
      {
        id: '6c31caf1-4d79-4abf-8c3e-dc50e263br3b',
        url: 'http://license.com',
      },
    ],
  },
];
